/**
 * "Rien ne reste à vérifier" / "1 information reste à vérifier" / "n informations restent à vérifier"
 * — read by the verification screen's progress card and by the dossier's `DocumentCard` alike, off the
 * server's own `progress.remaining` count.
 */
const formatRemainingToVerify = (remaining: number): string => {
	if (remaining === 0) {
		return 'Rien ne reste à vérifier';
	}

	return remaining === 1
		? '1 information reste à vérifier'
		: `${remaining} informations restent à vérifier`;
};

export default formatRemainingToVerify;
